<template>
    <v-dialog
        v-model="dialog"
        max-width="920"
        v-if="template != null"
    >
        <v-card>
            <v-card-title class="headline">
                {{template.label}}
            </v-card-title>

            <v-card-text>

                <v-text-field
                    label="Name"
                    v-model="bulk_message_label"
                    autocomplete="off"
                    autofocus
                >
                </v-text-field>

                <div
                    v-html="$rc.wrapHTML(template.message_patterns[0])"
                />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="dialog = false;"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                    :disabled="!isValid()"
                >
                    Create New Bulk Message Based On This Template
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');
export default {
    data() {
        return {
            template: null,
            bulk_message_label: '',
            template_bulk_message: null,
            dialog: false,
        }
    },

    methods: {

        showDialog(template)
        {
            this.template = template;

            let month = new Date().toLocaleString('default', { month: 'long' });
            let year = new Date().getFullYear();

            this.bulk_message_label = month+' '+year+': '+template.label;
            this.dialog = true;
        },

        isValid()
        {
            if ( this.bulk_message_label == null || this.bulk_message_label == '' || this.bulk_message_label.trim() == '' ) return false;
            return true;
        },

        onOk() {
            this.dialog = false;
          
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'POST: /api/v1/bulk/templates/create-bulk-message-from-template',
            
                'params' : {
                        'template_id' : this.template.template_id,
                        'for_organization_id' : this.$rc.$state.organization_id,
                        'label': this.bulk_message_label,
                    },
            
                'on_success': (data) => {
                        
                        this.$router.push({
                            'name': 'view-bulk-message',
                            'params' : {
                                'bulk_message_id': data.bulk_message_id
                            }
                        });
                        
                    },
            
                'on_error': 'Unable to create new bulk message based on template',
            });
        },
    },
}
</script>
